import {CanActivateFn, Router} from '@angular/router';
import { inject } from '@angular/core';
import {getCurrentUser} from "aws-amplify/auth";


export const authGuard: CanActivateFn = (route, state) => {

  const router = inject(Router);

  return getCurrentUser()
    .then((user) => {
      return true ;
    })
    .catch((err) => {
      const url = router.parseUrl('/auth');
      url.queryParams = {
        returnUrl: state.url
      }
      return url ;
    });

};
